import { PROJECT_COMPONENTS, PROJECT_USERS } from "services/endPoints";
import { privateRequest } from "services/privateRequest";

export const getProjectComponents = async ({
  pageNo = 1,
  pageSize = 10,
  search = "",
  signal,
} = {}) => {
  const response = await privateRequest.get(PROJECT_COMPONENTS, {
    params: {
      pageNo,
      pageSize,
      search,
    },
    signal,
  });

  return response?.data;
};

export const createProjectComponent = async (payload) => {
  const response = await privateRequest.post(PROJECT_COMPONENTS, payload);

  return response?.data;
};

export const updateProjectComponent = async (componentId, payload) => {
  const response = await privateRequest.put(
    `${PROJECT_COMPONENTS}/${componentId}`,
    payload
  );

  return response?.data;
};

export const deleteProjectComponent = async (componentId, payload = {}) => {
  const response = await privateRequest.delete(
    `${PROJECT_COMPONENTS}/${componentId}`,
    { data: payload }
  );

  return response?.data;
};

export const getComponentById = async (componentId) => {
  const response = await privateRequest.get(
    `${PROJECT_COMPONENTS}/${componentId}`);

  return response?.data;
}
export const getProjectUsers = async ({
  projectId,
  pageNo = 1,
  pageSize = 100,
  search = "",
  projectRole = "",
  signal,
} = {}) => {
  const response = await privateRequest.get(
    `${PROJECT_USERS}/${projectId}/users`,
    {
      params: {
        pageNo,
        pageSize,
        search,
        projectRole,
      },
      signal,
    }
  );

  return response?.data;
};
